module.exports = __webpack_public_path__ + "img/drawgrind.7a17ea95.png";